import React, { useState } from 'react'
import numeral from 'numeral'
import { Query } from 'react-apollo'
import {
  Col, Select, Input, Switch, Checkbox,
} from 'antd'
import * as UI from 'konsys-ui'
import moment from 'moment'
import _ from 'lodash'
import {
 detailMode, specialReason, status, statusText,
} from '../constants'
import { DatePicker, AutoComplete } from '../styled'
import { GET_FLEETS, GAS_STATION_LIST } from '../../../constants/graphql/query'
import { theme } from '../../../styles/_variables'
import { checkFloat, checkURLIsImage } from '../../../utils/util-services'
import { InputWithLabelBlock, DatePickerWithLabel } from '../../../components/shipping-order-components'
import FILLING_COMPANY from '../../../constants/filling-order'
import { UploadWithModal } from '../../../components/common'

const { color } = theme

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text with label
3: Dropdown (Select)
4: Radio box
5: Upload box
6: Button
7: Date picker
8: Autocomplete
9: Select (fuel)
10: Select (status)
11: remark
12: Select (gas)
13: Show company name
14: Show status
*/

const truckTypeSelector = (value) => {
  switch (value) {
    case 'PADOONGRICH':
      return 'ผดุงฤทธิ์'
    case 'JOINTCAR':
      return 'รถร่วมในเครือ'
    case 'OUTJOINTCAR':
      return 'รถร่วมนอก'
    default: return 'ไม่ระบุ'
  }
}

export const fuelTypeList = [
  { value: 'DIESEL', text: 'ดีเซล' },
  { value: 'DIESELPREMIUM', text: 'ดีเซล พรีเมี่ยม' },
  { value: 'LPG', text: 'LPG' },
  { value: 'NGV', text: 'NGV' },
  { value: 'B10', text: 'ดีเซล B10' },
  { value: 'B20', text: 'ดีเซล B20' },
  { value: 'E85', text: 'แก๊สโซฮอล์ E85' },
  { value: 'E20', text: 'แก๊สโซฮอล์ E20' },
  { value: 'GASOHOL91', text: 'แก๊สโซฮอล์ 91' },
  { value: 'GASOHOL95', text: 'แก๊สโซฮอล์ 95' },
  { value: 'GASOLINE', text: 'เบนซิน' },
]

export const statusList = [
  { value: 'WAITING', text: 'รอเบิก', color: color.coolGrey },
  { value: 'EXPIRED', text: 'หมดอายุ', color: color.error },
  { value: 'PRINTED', text: 'พิมพ์ใบเบิกแล้ว', color: color.wildWillow },
  { value: 'FILLED', text: 'เติมแล้ว', color: color.success },
  { value: 'BILLED', text: 'ได้รับบิลแล้ว', color: color.info },
  { value: 'CANCELLED', text: 'ยกเลิก', color: color.error },
  { value: 'LOST', text: 'สูญหาย', color: color.lost },
]

const CreateMode = ({ data, initialData, onChangeHandler }) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}><UI.InputWithLabel {...data.props} width='100%' input={{ onChange: e => onChangeHandler(data.id, e.target.value), ...data.props.input }} /></Col>
      )
    case 2:
      return <Col span={data.span}>
          <UI.Div display='flex' flexDirection={data.direction} margin='8px 0 0 0'>
            <UI.P margin={data.direction === 'column' ? '0 0 20px' : '0 20px 0 0' }>{data.props.title.text}</UI.P>
            <UI.P margin='0 0 20px'>{data.label}</UI.P>
          </UI.Div>
        </Col>
    case 7:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.P>{data.label}</UI.P>
          <DatePicker
            onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
            {...data.props}/>
        </Col>
      )
    case 8: // only fleet
      return (
        <Query
          query={GET_FLEETS}
        >{({ data: fleetData, loading, error }) => {
          if (loading) return <UI.Loading />
          if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
          return (
            <Col
              span={data.span}
              style={{ alignSelf: 'flex-end' }}
            >
              <UI.P>{data.label}</UI.P>
              <AutoComplete
                {...data.props}
                dataSource={fleetData.FleetList.lists.map(v => v.name)}
                style={{ width: '100%' }}
                onSelect={e => onChangeHandler(data.id, e)}
                onSearch={e => onChangeHandler(data.id, e)}
                filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
              />
            </Col>
          )
        }}
        </Query>
      )
    case 9:
      return (
        <Col
        span={data.span}
        style={{}}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='8px 0 16px'>{data.label}</UI.P>
          <Select
            showSearch
            onChange={(e) => {
              onChangeHandler(data.id, e)
            }}
          >
          {
            initialData.map((v, i) => <Select.Option key={i} value={v}>{v}</Select.Option>)
          }
          </Select>
        </UI.Div>
      </Col>
      )
    case 17:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
        </Col>
      )
    case 17.1:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
        </Col>
      )
    case 17.2:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler, mutationVariables,
}) => {
  const [gasStationSearch, setGasStationSearch] = useState()
  const pricePerLitre = _.isUndefined(mutationVariables.pricePerLitre) ? initialData.pricePerLitre : mutationVariables.pricePerLitre
  const totalAmount = _.isUndefined(mutationVariables.totalAmount) ? initialData.totalAmount : mutationVariables.totalAmount
  const expiredDate = _.isUndefined(mutationVariables.expiredDate) ? initialData.expiredDate : mutationVariables.expiredDate
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset} style={{ margin: data.margin ? data.margin : '0 0 16px' }}>
          <UI.InputWithLabel width='100%' {...data.props} input={{
            disabled,
            defaultValue: initialData[data.id],
            onChange: e => onChangeHandler(data.id, data.dataType === 'float' ? parseFloat(e.target.value) : e.target.value),
            // TODO: TOP create keycode array
            onKeyDown: (e) => {
              if (data.dataType === 'float' && !checkFloat(e)) {
                e.preventDefault()
              }
            },
            ...data.props.input,
            type: data.dataType === 'float' ? 'number' : 'text',
            step: data.dataType === 'float' ? '0.1' : undefined,
            min: '0',
          }} />
        </Col>
      )
    case 2:
      return <Col span={data.span} offset={data.offset}>
            <UI.Div display='flex' flexDirection={data.direction} margin={data.margin ? data.margin : '0'}>
              <UI.P margin={data.direction === 'column' ? '0 0 16px' : '0 16px 0 0' }>{data.props.title.text}<span style={{ fontWeight: 400 }}>{!data.direction && ' :'}</span></UI.P>
              <UI.P bold margin='0 0 16px'>{data.dataType === 'date'
                ? moment(initialData[data.id]).format('YYYY-MM-DD')
                : data.dataType === 'time'
                  ? moment(initialData[data.id]).format('HH:mm')
                  : data.id === 'jobDealType'
                    ? (initialData[data.id] === 'PERWEIGHT' ? 'ต่อน้ำหนัก' : 'ต่อเที่ยว')
                    : data.id === 'truckCategory'
                      ? truckTypeSelector(initialData[data.id])
                      : initialData[data.id]}</UI.P>
            </UI.Div>
          </Col>
    case 3:
      return <Col span={data.span} offset={data.offset}>
      <UI.Div display='flex' flexDirection='column' margin='8px 0 12px'>
        <UI.P margin='0 0 16px'>{data.label}</UI.P>
        <UI.P bold>
          {
            data.id === 'totalPrice'
              ? `${numeral(pricePerLitre * totalAmount).format('0,0.00')} บาท`
              : `${numeral(pricePerLitre * initialData.filledAmount).format('0,0.00')} บาท`
          }
        </UI.P>
      </UI.Div>
    </Col>
    case 7:
      return (
          <Col
            span={data.span}
            offset={data.offset}
          >
            <UI.Div margin='8px 0 0 0'>
              <DatePickerWithLabel
                data={{
                  disabled,
                  defaultValue: _.isNull(initialData[data.id]) ? initialData[data.id] : moment(initialData[data.id]),
                  value: moment(expiredDate),
                  id: data.id,
                  text: 'วันหมดอายุ',
                }}
                onChangeHandler={(key, value) => onChangeHandler(key, value)}
                />
              </UI.Div>
          </Col>
      )
    case 8:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div margin='0 0 16px 0'>
          <UI.H4 bold {...data.props}>{data.label}</UI.H4>
        </UI.Div>
        </Col>
    case 9:
      return <Col span={data.span} offset={data.offset} style={{ margin: '0 0 16px' }}>
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='8px 0 16px'>{data.label}</UI.P>
          <Select
            showSearch
            disabled={disabled}
            defaultValue={initialData[data.id]}
            onChange={(e) => {
              onChangeHandler(data.id, e)
            }}
          >
          {
            fuelTypeList.map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
          }
          </Select>
          </UI.Div>
        </Col>
    case 11:
      return <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <Input.TextArea disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)}/>
          </UI.Div>
        </Col>
    // case 12:
    //   return <Col span={data.span} offset={data.offset} style={{ margin: '0 0 12px' }}>
    //     <UI.Div display='flex' flexDirection='column'>
    //       <UI.P margin='8px 0 16px'>{data.label}</UI.P>
    //       <Select
    //         showSearch
    //         disabled={disabled}
    //         defaultValue={initialData.gasstationCode}
    //         onChange={(e) => {
    //           onChangeHandler(data.id, e)
    //           onChangeHandler('gasstationId', _.find(gasList, v => v.code === e).id)
    //         }}
    //       >
    //       {
    //         gasList.map((v, i) => <Select.Option key={i} value={v.code}>{v.code}</Select.Option>)
    //       }
    //       </Select>
    //       </UI.Div>
    //     </Col>
    case 12:
      return (
        <Col span={data.span} offset={data.offset} style={{ margin: '0 0 12px' }}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='8px 0 16px'>{data.label}</UI.P>
            <Query
              query={GAS_STATION_LIST}
              variables={{ name: gasStationSearch, isActive: true }}
            >{(resp) => {
              if (resp.loading && _.isUndefined(resp.data.GasstationList)) return <UI.Loading size='small'/>
              if (resp.error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
              const GasStationList = resp.data.GasstationList.lists.map(v => ({ id: v.id, name: v.name }))
              return (
                <Select
                  loading={resp.loading}
                  defaultValue={initialData.gasstationName}
                  disabled={disabled}
                  showSearch
                  optionFilterProp="children"
                  style={{ width: '100%' }}
                  notFoundContent={resp.loading ? <UI.Loading size='small'/> : null}
                  onSearch={e => setGasStationSearch(e)}
                  onChange={(e) => {
                    const selected = _.find(resp.data.GasstationList.lists, o => o.id === e)
                    onChangeHandler(data.id, selected)
                    // onChangeHandler('gasstationId', _.isNaN(parseInt(selected.id, 10)) ? undefined : parseInt(selected.id, 10))
                  }}
                  placeholder='พิมพ์รหัสปั๊มน้ำมัน'
                >
                {
                  GasStationList.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
                }
                </Select>
              )
            }}
            </Query>
          </UI.Div>
        </Col>
      )
    case 13:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' margin='8px 0 12px'>
          <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
          <UI.P bold>
            {
              data.id === 'filledAmount'
                ? `${initialData[data.id]} ลิตร`
                : data.id === 'gasstationName'
                  ? _.isUndefined(mutationVariables.gasstationId) ? initialData.Gasstation.code : mutationVariables.gasCode
                  : data.id === 'gasstationCompany'
                    ? _.isUndefined(mutationVariables.gasstationId) ? initialData.Gasstation.company : mutationVariables.gasCompany
                    : initialData[data.id]
            }
          </UI.P>
        </UI.Div>
      </Col>
    case 14:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection={data.direction} margin={data.margin ? data.margin : '8px 0 12px'}>
          <UI.P margin={data.direction === 'column' ? '0 0 16px' : '0 16px 0 0' }>{data.props.title.text}<span style={{ fontWeight: 400 }}>{!data.direction && ' :'}</span></UI.P>
          <UI.P
            bold
            color={initialData[data.id] === status.WAITING
              ? color.coolGrey
              : initialData[data.id] === status.EXPIRED
                ? color.error
                : initialData[data.id] === status.FILLED
                  ? color.success
                  : initialData[data.id] === status.BILLED
                    ? color.info
                    : initialData[data.id] === status.CANCELLED
                      ? color.error
                      : initialData[data.id] === status.PRINTED
                        ? color.wildWillow
                        : initialData[data.id] === status.LOST && color.lost}
          >{initialData[data.id] === status.WAITING
            ? statusText.WAITING
            : initialData[data.id] === status.EXPIRED
              ? statusText.EXPIRED
              : initialData[data.id] === status.FILLED
                ? statusText.FILLED
                : initialData[data.id] === status.BILLED
                  ? statusText.BILLED
                  : initialData[data.id] === status.CANCELLED
                    ? statusText.CANCELLED
                    : initialData[data.id] === status.PRINTED
                      ? statusText.PRINTED
                      : statusText.LOST}</UI.P>
        </UI.Div>
      </Col>
    case 15:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' margin={data.margin ? data.margin : '0'}>
          <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
          <UI.Div margin='0 0 16px'>
            <UI.P bold margin='0'>{initialData[`${data.id}Id`]} - {initialData[data.id]}</UI.P>
          </UI.Div>
        </UI.Div>
      </Col>
    case 16:
      return (
        <Col span={data.span}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            showUploadList={{
              showRemoveIcon: !disabled,
            }}
            defaultFileList={!_.isNull(initialData[data.id]) && initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            listType="picture"
            onChange={(e) => {
              onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))
            }}
            button={data.props}
          />
        </Col>
      )
    case 17:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
          <InputWithLabelBlock
            maxLength={5}
            isFloat={!disabled}
            data={{
              disabled,
              defaultValue: disabled ? numeral(initialData[data.id]).format('0,0.00') : initialData[data.id],
              id: data.id,
              props: { ...data.props },
            }}
            onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
        </Col>
      )
    case 17.1:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
        <InputWithLabelBlock
          maxLength={5}
          isFloat={!disabled}
          data={{
            disabled,
            defaultValue: disabled ? numeral(initialData[data.id]).format('0,0.00') : initialData[data.id],
            value: pricePerLitre,
            id: data.id,
            props: { ...data.props },
          }}
          onChangeHandler={(key, value) => {
            if (_.isNaN(value) || (value >= 0 && value <= 80)) onChangeHandler(key, value, true)
          }}
        />
        </Col>
      )
    case 17.2:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
        <InputWithLabelBlock
          maxLength={5}
          isFloat={!disabled}
          data={{
            disabled: (
              (window.role === 'SuperAdmin' || (window.role === 'Route Planner' && initialData.isSpecial))
              ? disabled
              : !_.includes([status.WAITING], initialData.status)) || disabled,
            defaultValue: disabled ? numeral(initialData[data.id]).format('0,0.00') : initialData[data.id],
            value: totalAmount,
            id: data.id,
            props: { ...data.props },
          }}
          onChangeHandler={(key, value) => {
            if (_.isNaN(value) || (value >= 0 && (value <= 500 || _.includes(FILLING_COMPANY, initialData.Job.Customer.companyName)))) onChangeHandler(key, value, true)
          }}
        />
        </Col>
      )
    case 18:
      return (initialData.status === 'LOST'
      && <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' margin='8px 0 12px'>
          <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
          <UI.P bold margin='0 0 24px' color={color.error}>
            {
              data.id === 'compensation'
                ? _.isNull(initialData[data.id]) ? '-' : `${numeral(initialData[data.id]).format('0,0.00')} บาท`
                : initialData.fuelcompensation.nextOrder
                  ? _.isNull(initialData[data.id]) ? '-' : `-${initialData[data.id]} ลิตร`
                  : 'ไม่หักออกจากใบเบิกครั้งหน้า'
            }
          </UI.P>
        </UI.Div>
      </Col>)
    case 19:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' margin={data.margin ? data.margin : '0'}>
          <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
          <UI.Div margin='0 0 16px'>
            <UI.P bold margin='0'>{initialData[data.id]} - {initialData.branch}</UI.P>
          </UI.Div>
        </UI.Div>
      </Col>
    case 20:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' margin={data.margin ? data.margin : '0'}>
          <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
          <UI.Div margin='0 0 16px'>
            <UI.P bold margin='0'>{initialData[data.id]} - {initialData[`${data.id}Branch`]}</UI.P>
          </UI.Div>
        </UI.Div>
      </Col>
    case 21:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' margin='8px 0'>
          <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
          <Select
            disabled={disabled}
            showSearch
            defaultValue={initialData[data.id]}
            optionFilterProp="children"
            onChange={(e) => {
              const targetObj = _.find(fuelTypeList, r => r.value === e)
              onChangeHandler('fuelType', targetObj.value)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
            {
              fuelTypeList.map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
            }
            </Select>
        </UI.Div>
      </Col>
    case 22:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' margin='8px 0'>
          <Checkbox
            defaultChecked={initialData[data.id]}
            disabled={true}
          >จ่ายเงินด้วย FleetCard</Checkbox>
        </UI.Div>
      </Col>
    case 23:
      if (!initialData.isSpecial) {
        return (
          <Col span={data.span} />
        )
      }
      return (
        <Col span={data.span}>
          <UI.Div display='flex' flexDirection='column' margin='8px 0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <Select
              style={{ width: '100%' }}
              disabled={disabled}
              defaultValue={initialData[data.id]}
              onChange={value => onChangeHandler(data.id, value)}
            >
              {
                Object.keys(specialReason).map(key => (
                  <Select.Option value={specialReason[key].value} key={key}>
                    {specialReason[key].label}
                  </Select.Option>
                ))
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 24: {
      if (!initialData.isSpecial) {
        return (
          <Col span={data.span} />
        )
      }
      const reason = mutationVariables.specialReason || initialData.specialReason
      return (
        <Col span={data.span}>
          <InputWithLabelBlock
            data={{
              id: data.id,
              disabled: disabled || reason !== specialReason.OTHER.value,
              value: !_.isUndefined(mutationVariables[data.id]) ? mutationVariables[data.id] : initialData[data.id],
              props: { ...data.props },
            }}
            onChangeHandler={(key, value) => onChangeHandler(key, value)}
          />
        </Col>
      )
    }
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.EDIT:
      return <EditMode data={data} mutationVariables={mutationVariables} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} mutationVariables={mutationVariables} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
